import Breadcrumb from "Components/UI/Breadcrumb";
import Spinners from "Components/UI/Spinner";
import PaginatedTable from "Components/Tables/PaginatedTable";
import React, { useEffect, useState } from "react";
import { Card, CardBody, Container } from "reactstrap";
import useTableFilters from "helpers/hooks/useTableFilters";
import { generateQueryParams } from "helpers/queryParams";
import { Link } from "react-router-dom";
import convertDateFormat from "Components/Date/DateFormat";
import DeleteModal from "Components/Modals/DeleteModal";
import { deletePage, getPages } from "helpers/API Calls/System & Settings/Pages";

const head = [
  { id: 0, name: "#", isSortable: true, key: "id" },
  { id: 1, name: "Title", isSortable: true, key: "title" },
  { id: 2, name: "Sub Title", isSortable: true, key: "sub_title" },
  // { id: 3, name: "Type", isSortable: true, key: "page_type_id" },
  { id: 4, name: "Featured", isSortable: true, key: "is_featured" },
  { id: 6, name: "SEO", isSortable: true, key: "is_seo" },
  { id: 5, name: "Status", isSortable: true, key: "status" },
  { id: 7, name: "Created", isSortable: true, key: "created_at" },
  { id: 8, name: "Updated", isSortable: true, key: "updated_at" },
  { id: 9, name: "Actions", isSortable: false, key: "actions" }
];

function Pages() {  
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [data, setData] = useState<any[]>([]);
    const [pagination, setPagination] = useState<any>({current_page: 1, last_page: 1, per_page: 10, total: 0});
  
    const [deleteModal, setDeleteModal] = useState<boolean>(false);
    const [selectedItem, setSelectedItem] = useState<any>(null);
    
    const { filters, updateFilter } = useTableFilters();
  
    const fetchData = async () => {
      setIsLoading(true);
      const response = await getPages(generateQueryParams(filters)+ '&page_type_id=1');
      if (response.success) {
        setData(response.data.items);
        setPagination(response.data.pagination);
      }
      setIsLoading(false);
    }
  
    useEffect(() => {
      fetchData();
    }, [filters]);
  
    const handleDeleteClick = (item) => {
      setSelectedItem(item);
      setDeleteModal(true);
    };
  
    const handleDeleteConfirm = async () => {
      if (selectedItem) {
        const response = await deletePage(selectedItem.id);
        if (response.success) {
          setDeleteModal(false);
          setSelectedItem(null);
          fetchData();
        }
      }
    };
  
    const onCloseClick = () => {
      setDeleteModal(false);
      setSelectedItem(null);
    };
  
  return (
    <>
    <div className="page-content">
      <Container fluid>
        <Breadcrumb items={[{ label: "Location Pages" }]} />
        {isLoading ? <div className="position-relative vh-100"><Spinners/></div>
        :
        <Card>
          <CardBody>
            <PaginatedTable
              tableHead={head}
              pagination={pagination}
              updateFilter={updateFilter}
              filters={filters}
              isAddButton={true}
              buttonText="Add New Page"
              to="create"
              > 
              {data.length > 0 && data.map((item) => (                
                <tr key={item.id}>
                  <td>{item.id}</td>
                  <td className="text-truncate">{item.title}</td>
                  <td className="text-truncate">{item.sub_title}</td>
                  {/* <td>{item?.page_type?.page_type}</td> */}
                  <td>
                    <span className={`badge badge-soft-${item.is_featured === '1' ? 'success' : 'secondary'}`}>
                      {item.is_featured === '1' ? 'Yes' : 'No'}
                    </span>
                  </td>
                  <td>
                    <span className={`badge badge-soft-${item.is_seo === '1' ? 'success' : 'secondary'}`}>
                      {item.is_seo === '1' ? 'Yes' : 'No'}
                    </span>
                  </td>
                  <td>
                    <span className={`badge badge-soft-${item.status === 1 ? 'success' : 'danger'}`}>
                      {item.status === 1 ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                  <td>{convertDateFormat(item.created_at)}</td>
                  <td>{convertDateFormat(item.updated_at)}</td>
                  <td>
                    <div>
                      <Link to={`${item.id}/edit`} className="btn btn-primary btn-sm mx-1"><i className="bx bx-pencil"/></Link>
                      <button className="btn btn-danger btn-sm" onClick={() => handleDeleteClick(item)}><i className="mdi mdi-trash-can-outline"></i></button>
                    </div>
                  </td>
                </tr>))
              }
              {!isLoading && data.length === 0 && <tr className="text-center"><td colSpan={head.length} className="text-danger">No Data Found</td></tr>}
            </PaginatedTable>
          </CardBody>
        </Card>
        }
      </Container>
    </div>
    {deleteModal && <DeleteModal
      show={deleteModal}
      onDeleteClick={handleDeleteConfirm}
      onCloseClick={onCloseClick}
      message={`"${selectedItem?.title}" page`}
    />}
    </>
  );
}

export default Pages;
